import { render, staticRenderFns } from "./CertificateAdministration.vue?vue&type=template&id=e2cadefe&scoped=true"
import script from "./CertificateAdministration.vue?vue&type=script&lang=ts"
export * from "./CertificateAdministration.vue?vue&type=script&lang=ts"
import style0 from "./CertificateAdministration.vue?vue&type=style&index=0&id=e2cadefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cadefe",
  null
  
)

export default component.exports